import(/* webpackMode: "eager" */ "/codebuild/output/src2410076634/src/apps/webapp/src/app/global-error.tsx");
